
// Extend element width to the right edge of the viweport
const dataToRight = () => {
  const elements = document.querySelectorAll("[data-to-right]");
  if (elements.length) {
    Object.values(elements).forEach((el) => {
      el.removeAttribute("style");

      setTimeout(() => {
        el.style.width = `${window.innerWidth - el.offsetLeft}px`;
      }, 0);
    });
  }
};

const dataToLeft = () => {
  const elements = document.querySelectorAll("[data-to-left]");
  if (elements.length) {
    Object.values(elements).forEach((el) => {
      el.removeAttribute("style");

      setTimeout(() => {
        el.style.marginLeft = `-${el.offsetLeft}px`;
        el.style.width = `${el.innerWidth + el.offsetLeft}px`;
      }, 0);
    });
  }
};

document.addEventListener('DOMContentLoaded', () => {
  dataToRight();
  dataToLeft();
})

window.addEventListener("resize", () => {
  dataToRight();
  dataToLeft();
});

import './modules'
import './forms'
